<template>
  <div class="usuarios">
    <el-tabs type="border-card" class="fullHeight">
      <el-tab-pane class="paddingBody content" label="Usuarios">
        <el-row>
          <el-col :span="24">
            <el-input
              :placeholder="$t('Búsqueda por nombre, apellido o RUT')"
              prefix-icon="el-icon-search"
              v-model="search"
              class="search"
              size="medium"
            />
            <el-button
              v-if="!$store.getters.user.readonly"
              size="small"
              type="primary"
              @click="newUser()"
              icon="el-icon-edit"
              class="right"
              >{{ $t("Nuevo Usuario") }}</el-button
            >
            <el-button
              size="small"
              class="right text-center sendEmail"
              icon="el-icon-message"
              @click="sendWelcomeEmail"
              :loading="sendingEmails"
              v-if="multipleSelection.length > 0"
              >{{ $t("Enviar email de bienvenida") }} ({{
                multipleSelection.length
              }})</el-button
            >
          </el-col>
        </el-row>
        <center v-if="loading">
          <br />
          <br />
          <Circle9 style="margin-bottom: 8px"></Circle9>
          <small>Cargando Datos ...</small>
          <br />
          <br />
        </center>
        <el-row v-else>
          <el-col :span="24">
            <el-table
              row-class-name="rowClassTablaPloma"
              cell-class-name="cellClassTablaPloma"
              header-cell-class-name="header-cell-class-table-gray"
              :max-height="700"
              class="usersTable"
              :data="paginar === false ? usuarios : paginarUsuarios()"
              ref="userTable"
              @selection-change="handleSelectionChange"
            >
              <el-table-column type="selection" align="center" width="55" />
              <el-table-column
                min-width="100px"
                prop="nombre"
                :label="$t('Nombre')"
                sortable
              />
              <el-table-column
                min-width="100px"
                prop="apellido"
                :label="$t('Apellido')"
                sortable
              />
              <el-table-column
                prop="rut"
                width="250px"
                :label="$t('Nombre de usuario')"
                sortable
              />
              <el-table-column
                prop="email"
                min-width="120px"
                :label="$t('Correo electrónico')"
                sortable
              />
              <el-table-column
                width="180"
                :label="$t('Administrador')"
                align="center"
              >
                <template slot-scope="scope">
                  <div v-if="scope.row.roles.admin" class="tagSuperadmin">
                    Super Administrador
                  </div>
                  <span v-else>N/A</span>
                </template>
              </el-table-column>
              <el-table-column width="130" align="center" v-if="!$store.getters.user.readonly">
                <template slot-scope="scope">
                  <el-button
                    icon="el-icon-edit-outline"
                    @click="showUser(scope.row)"
                    size="small"
                    type="primary"
                    >{{ $t("Modificar") }}</el-button
                  >
                </template>
              </el-table-column>
              <el-table-column
                v-if="!$store.getters.user.readonly"
                width="180"
                align="center"
              >
                <template slot-scope="scope">
                  <el-button
                    icon="el-icon-more"
                    @click="openSetPassword(scope.row)"
                    size="small"
                    type="info"
                    >{{ $t("Cambiar Contraseña") }}</el-button
                  >
                </template>
              </el-table-column>
              <el-table-column
                v-if="!$store.getters.user.readonly"
                width="120"
                align="center"
              >
                <template slot-scope="scope">
                  <el-button
                    v-if="
                      [
                        '642198cb8c03c500123c0d94',
                        '655ca26350599500126cc6e2',
                        '5e41686693114800178f246f',
                        '608c08fc3fdf700017e11c95',
                        '5b929a761616050010f76dff',
                        '59cbfb0c0a1d7d0011ba7860',
                      ].includes($store.getters.user._id)
                    "
                    @click="eliminarUsuario(scope.row)"
                    size="small"
                    icon="el-icon-delete"
                    type="danger"
                    >{{ $t("Eliminar") }}</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <br />
            <br />
            <center>
              <el-pagination
                :current-page="page"
                @prev-click="backPage"
                @next-click="nextPage"
                @current-change="currentPage"
                :page-size="6"
                layout="prev, pager, next"
                :total="totalPage"
              ></el-pagination>
            </center>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>

    <DialogAddUser
      :user="user"
      :visibleSync="dialogUser"
      :action="action"
      :findUser="findUser"
      :onCancel="cleanUser"
      :onAcept="createUpdateUser"
    />

    <el-dialog
      :title="nombre_user"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <el-form
        style="margin-top: 15px"
        label-position="top"
        label-width="100px"
      >
        <el-form-item label="Contraseña">
          <el-input
            type="password"
            v-model="password"
            :keyup="validPass(password)"
          ></el-input>
        </el-form-item>
        <el-form-item label="Repita su Contraseña">
          <el-input type="password" v-model="password_repeat"></el-input>
        </el-form-item>
        <span
          ><el-icon
            v-if="pass_1"
            style="color: green"
            class="el-icon-success"
          ></el-icon
          ><el-icon v-else style="color: red" class="el-icon-error"></el-icon>
          Longitud mínima 8</span
        ><br />
        <span
          ><el-icon
            v-if="pass_2"
            style="color: green"
            class="el-icon-success"
          ></el-icon
          ><el-icon v-else style="color: red" class="el-icon-error"></el-icon>
          Longitud máxima 100</span
        ><br />
        <span
          ><el-icon
            v-if="pass_3"
            style="color: green"
            class="el-icon-success"
          ></el-icon
          ><el-icon v-else style="color: red" class="el-icon-error"></el-icon>
          Debe tener letras mayúsculas</span
        ><br />
        <span
          ><el-icon
            v-if="pass_4"
            style="color: green"
            class="el-icon-success"
          ></el-icon
          ><el-icon v-else style="color: red" class="el-icon-error"></el-icon>
          Debe tener letras minúsculas</span
        ><br />
        <span
          ><el-icon
            v-if="pass_5"
            style="color: green"
            class="el-icon-success"
          ></el-icon
          ><el-icon v-else style="color: red" class="el-icon-error"></el-icon>
          Debe tener al menos 2 dígitos</span
        ><br />
        <span
          ><el-icon
            v-if="pass_6"
            style="color: green"
            class="el-icon-success"
          ></el-icon
          ><el-icon v-else style="color: red" class="el-icon-error"></el-icon>
          No debe tener espacios</span
        >
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="handleClose">Cancelar</el-button>
        <el-button size="medium" type="primary" @click="setPassword"
          >Aceptar</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Circle9 } from "vue-loading-spinner";
import { mapActions } from "vuex";
import axios from "axios";
import DialogAddUser from "@/components/dialogAddUser.vue";

const SERVICE_EMAIL_URL = "/usuarios/mailing/bienvenida";

export default {
  name: "Usuarios",
  data() {
    return {
      loading: false,
      page: 1,
      totalPage: 0,
      findUser: false,
      usuarios: [],
      dialogUser: false,
      activeName: "area-roles",
      user: {},
      action: "update",
      sendingEmails: false,
      multipleSelection: [],
      search: "",
      paginar: false,
      id_user: "",
      nombre_user: "",
      dialogVisible: false,
      password: "",
      password_repeat: "",
      pass_1: false,
      pass_2: false,
      pass_3: false,
      pass_4: false,
      pass_5: false,
      pass_6: false,
    };
  },
  async created() {
    this.setSubTitle("Administración de Usuarios");
    this.getAreasFaena();
    this.getEmpresasFaena();
    this.listadoUsuarios(1, this.search);
  },
  components: {
    DialogAddUser,
    Circle9,
  },
  watch: {
    "user.rut": function () {
      this.debounceInput();
    },
    search() {
      this.loading = true;
      this.debounceInputSearch();
    },
  },
  methods: {
    ...mapActions(["setSubTitle", "getEmpresasFaena", "getAreasFaena"]),
    eliminarUsuario(user) {
      this.$confirm(
        `Estás a punto de eliminar el usuario ${user.nombre} ${user.apellido}, ¿Estás seguro que deseas continuar?`,
        "Advertencia",
        {
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          type: "warning",
        }
      ).then(() => {
        axios
          .post(
            `/usuarios/delete_user`,
            { _id: user._id, user: this.$store.getters.user._id },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          )
          .then((response) => {
            if (response.data.success === true) {
              this.$notify.success({
                title: this.$t("Éxito"),
                message: this.$t(response.data.message),
              });
              this.listadoUsuarios(this.page, this.search);
            } else {
              this.$notify.error({
                title: this.$t("Error"),
                message: this.$t(response.data.message),
              });
            }
          });
      });
    },
    openSetPassword(user) {
      this.id_user = user._id;
      this.nombre_user = `${user.nombre} ${user.apellido}`;
      this.dialogVisible = true;
    },
    setPassword() {
      if (this.password !== this.password_repeat) {
        this.$alert(
          "Las contraseñas ingresadas no coinciden",
          "Información importante",
          {
            type: "error",
            confirmButtonText: "Aceptar",
            callback: (action) => {},
          }
        );
      } else {
        var passwordValidator = require("password-validator");

        // Create a schema
        var schema = new passwordValidator();

        // Add properties to it
        schema
          .is()
          .min(8) // Minimum length 8
          .is()
          .max(100) // Maximum length 100
          .has()
          .uppercase() // Must have uppercase letters
          .has()
          .lowercase() // Must have lowercase letters
          .has()
          .digits(2) // Must have at least 2 digits
          .has()
          .not()
          .spaces() // Should not have spaces
          .is()
          .not()
          .oneOf([]); // Blacklist these values

        if (schema.validate(this.password)) {
          this.updatePassword();
        } else {
          this.$alert(
            "La contraseña ingresada no cumple con los requisitos solicitados",
            "Información importante",
            {
              type: "error",
              confirmButtonText: "Aceptar",
              callback: (action) => {},
            }
          );
        }
      }
    },
    validPass(pass) {
      // minimo de 8
      if (pass.length >= 8) {
        this.pass_1 = true;
      } else {
        this.pass_1 = false;
      }
      // maximo de 100
      if (pass.length <= 100) {
        this.pass_2 = true;
      } else {
        this.pass_2 = false;
      }
      // mayusculas
      if (this.tiene_mayusculas(pass) === true) {
        this.pass_3 = true;
      } else {
        this.pass_3 = false;
      }
      // minusculas
      if (this.tiene_minusculas(pass) === true) {
        this.pass_4 = true;
      } else {
        this.pass_4 = false;
      }
      // minimo dos numeros
      if (this.getNumbersInString(pass).length >= 2) {
        this.pass_5 = true;
      } else {
        this.pass_5 = false;
      }
      // sin espacios
      var noValido = / /;
      if (noValido.test(pass)) {
        this.pass_6 = false;
      } else {
        this.pass_6 = true;
      }
    },
    getNumbersInString(string) {
      var tmp = string.split("");
      var map = tmp.map(function (current) {
        if (!isNaN(parseInt(current))) {
          return current;
        }
      });

      var numbers = map.filter(function (value) {
        return value != undefined;
      });

      return numbers.join("");
    },
    tiene_minusculas(texto) {
      var letras = "abcdefghyjklmnñopqrstuvwxyz";
      for (var i = 0; i < texto.length; i++) {
        if (letras.indexOf(texto.charAt(i), 0) != -1) {
          return true;
        }
      }
      return false;
    },
    tiene_mayusculas(texto) {
      var letras_mayusculas = "ABCDEFGHYJKLMNÑOPQRSTUVWXYZ";
      for (var i = 0; i < texto.length; i++) {
        if (letras_mayusculas.indexOf(texto.charAt(i), 0) != -1) {
          return true;
        }
      }
      return false;
    },
    async updatePassword() {
      const response = await axios.post(
        `/usuarios/setPassword/${this.id_user}`,
        {
          password: this.password,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if (response.data.success === true) {
        this.$alert(response.data.message, "Información importante", {
          type: "success",
          confirmButtonText: "Aceptar",
          callback: (action) => {
            this.handleClose();
          },
        });
      } else {
        this.$alert(response.data.message, "Información importante", {
          type: "error",
          confirmButtonText: "Aceptar",
          callback: (action) => {
            this.handleClose();
          },
        });
      }
    },
    handleClose() {
      this.dialogVisible = false;
      this.password = "";
      this.password_repeat = "";
      this.pass_1 = false;
      this.pass_2 = false;
      this.pass_3 = false;
      this.pass_4 = false;
      this.pass_5 = false;
      this.pass_6 = false;
    },
    currentPage(page) {
      this.page = page;
      this.listadoUsuarios(page, this.search);
    },
    nextPage(page) {
      this.page = page;
      this.listadoUsuarios(page, this.search);
    },
    backPage(page) {
      this.page = page;
      this.listadoUsuarios(page, this.search);
    },
    debounceInput: _.debounce(function () {
      if (Object.keys(this.user).length > 0 && this.user.rut !== "") {
        this.findUser = true;
        const userExist = this.$store.getters.usersFaena.find(
          (x) => x.rut === this.user.rut
        );
        if (userExist) {
          this.findUser = false;
          this.action = "update";
          this.user = userExist;
          this.user = {
            _id: userExist._id,
            nombre: userExist.nombre,
            apellido: userExist.apellido,
            rut: userExist.rut,
            email: userExist.email,
            roles: userExist.roles,
          };
        } else {
          axios
            .get(`/usuarios/by_rut/${this.user.rut}`, {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            })
            .then((response) => {
              if (response.data.hasOwnProperty("success")) {
                this.findUser = false;
                (this.user._id = "Create"),
                  (this.user.nombre = ""),
                  (this.user.apellido = ""),
                  (this.user.email = ""),
                  (this.user.roles = {
                    admin: false,
                  }),
                  (this.action = "create");
                this.$notify.info({
                  title: "Información",
                  message: "Usuario no encontrado.",
                });
              } else {
                this.findUser = false;
                this.action = "update";
                (this.user._id = response.data._id),
                  (this.user.nombre = response.data.nombre),
                  (this.user.apellido = response.data.apellido),
                  (this.user.rut = response.data.rut),
                  (this.user.email = response.data.email);
              }
            });
        }
      }
    }, 1500),
    debounceInputSearch: _.debounce(function () {
      this.page = 1;
      this.listadoUsuarios(this.page, this.search);
    }, 1200),
    listadoUsuarios(page, search) {
      this.loading = true;
      const self = this;
      axios
        .get(
          `/usuarios/getAllUsers/${this.$store.getters.role.faena_id}/${page}/${
            search === "" ? undefined : search
          }`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        )
        .then((response) => {
          self.usuarios = response.data.results;
          self.totalPage = response.data.total;
          self.paginar = response.data.paginar;
          self.loading = false;
        });
    },
    paginarUsuarios() {
      return this.usuarios.slice((this.page - 1) * 6, this.page * 6);
    },
    // NUEVO
    newUser() {
      // JSON.parse(JSON.stringify())
      // para evitar warning de mutación fuera del store.
      this.user = {
        _id: "",
        nombre: "",
        apellido: "",
        rut: "",
        email: "",
        roles: {
          admin: false,
        },
      };
      this.action = "create";
      this.dialogUser = true;
    },
    showUser(user) {
      // JSON.parse(JSON.stringify())
      // para evitar warning de mutación fuera del store.
      this.findUser = false;
      this.user = JSON.parse(JSON.stringify(user));
      this.action = "update";
      this.dialogUser = true;
    },
    async createUpdateUser(action) {
      const auxUser = {
        user: {
          _id: this.user._id,
          nombre: this.user.nombre,
          apellido: this.user.apellido,
          rut: this.user.rut,
          email: this.user.email,
          created_by: this.$store.getters.user._id,
        },
      };
      const auxRoles = {
        faenaId: this.$store.getters.role.faena_id,
        module: "inventarios",
        permissions: this.user.roles,
      };
      if (action === "create") {
        await this.createUser(auxUser, auxRoles);
      } else if (action === "update") {
        await this.updateUser(auxUser, auxRoles);
      }
    },
    async createUser(userToCreate, roles) {
      const userCreated = await this.$store.dispatch(
        "createUser",
        userToCreate
      );
      if (userCreated && userCreated.success && userCreated.userId) {
        const rolesCreated = await this.$store.dispatch(
          "updateUsersRoles",
          Object.assign({}, { userId: userCreated.userId }, roles)
        );
        if (rolesCreated) {
          this.listadoUsuarios(this.page, this.search);
          this.dialogUser = false;
          this.cleanUser();
          this.$notify.success({
            title: "Éxito",
            message: "Usuario creado exitosamente",
          });
        } else {
          this.$notify.error({
            title: "Error",
            message: "No fue posible asignar roles al usuario",
          });
        }
      } else {
        this.$notify.error({
          title: "Error",
          message: "No fue posible crear el usuario",
        });
      }
    },
    async updateUser(userToUpdate, roles) {
      const userUpdated = await this.$store.dispatch(
        "updateUser",
        userToUpdate
      );
      if (userUpdated) {
        const rolesUpdated = await this.$store.dispatch(
          "updateUsersRoles",
          Object.assign({}, { userId: this.user._id }, roles)
        );
        if (rolesUpdated) {
          this.listadoUsuarios(this.page, this.search);
          this.dialogUser = false;
          this.cleanUser();
          this.$notify.success({
            title: "Éxito",
            message: "Usuario editado exitosamente",
          });
        } else {
          this.$notify.success({
            title: "Error",
            message: "No fue posible actualizar roles del usuario",
          });
        }
      } else {
        this.$notify.success({
          title: "Error",
          message: "No fue posible actualizar el usuario",
        });
      }
    },
    cleanUser() {
      this.dialogUser = false;
      this.findUser = false;
      this.user = {};
    },
    cleanAux() {
      this.auxAC = {
        title: "",
        acs: [],
        roles: {},
      };
      this.auxUserACRoles = {
        type: "bhp",
        key: "",
        roles: [],
      };
    },
    // ANTIGUO
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    sendWelcomeEmail() {
      this.sendingEmails = true;
      const users = this.multipleSelection.map((user) => user._id);
      const config = {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      };
      axios
        .post(SERVICE_EMAIL_URL, { userIDs: users }, config)
        .then((response) => {
          this.sendingEmails = false;
          this.multipleSelection = [];
          this.$refs.userTable.clearSelection();
          this.$alert(
            "Emails de bienvenida han sido enviados exitosamente.",
            "Proceso exitoso",
            {
              type: "success",
            }
          );
        })
        .catch((error) => {
          this.sendingEmails = false;
          console.error(error);
          this.$alert(
            "Lo sentimos, ha surgido un error. Intente nuevamente.",
            "Atención",
            {
              type: "error",
            }
          );
        });
    },
  },
};
</script>

<style scoped>
.tagSuperadmin {
  font-size: 13px;
  border-radius: 3px;
  border: 1px solid #4f914f;
  background-color: #d3ebcd;
  color: #4f914f;
  margin: 4px auto;
  width: 130px;
}
.ver {
  cursor: pointer;
}
.sendEmail {
  width: 300px;
  margin-right: 20px;
}
.checkbox-roles {
  margin-top: 30px;
}
.usersTable {
  margin-top: 40px;
}
.dialog-title {
  line-height: 40px;
  font-size: 18px;
  color: #303133;
}
.search {
  max-width: 450px;
  float: left;
}
.content {
  min-height: 50vh;
}
</style>
